import React, { PropsWithChildren, ReactElement, ReactNode } from 'react'
import { Platform, Pressable, PressableProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native'

import { Spacing, Color } from '../../style'
import { Icon } from '../icon'
import { Text } from '../typography'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minHeight: 50,
    padding: Spacing.S,
    borderWidth: 1,
    borderColor: Color.simplyWhite,
  },
  pressed: {
    backgroundColor: Color.sleepingGrey,
    borderColor: Color.sleepingGrey,
  },
  hovered: {
    borderColor: Color.sleepingGrey,
  },
  disabled: {
    opacity: 0.4,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  content: {
    flex: 1,
    justifyContent: 'center',
  },
  right: {
    marginLeft: Spacing.XS,
  },
})

interface Addon {
  left?: ReactNode
  right?: ReactNode
}

export interface Props extends Omit<PressableProps, 'style'> {
  style?: StyleProp<ViewStyle>
  title?: string | ReactElement
  description?: string | ReactElement
  addon?: Addon
  chevron?: boolean
}
const ListItem = (props: PropsWithChildren<Props>) => {
  const { title, description, addon, chevron, onPress, disabled, children, ...otherProps } = props

  const renderItem = (state: { pressed: boolean; hovered?: boolean }) => {
    const { pressed, hovered } = state
    return (
      <View
        style={[styles.container, pressed && styles.pressed, hovered && styles.hovered, disabled && styles.disabled]}
        testID="Menu.Content"
      >
        <View style={styles.row}>
          {addon?.left}
          <View style={styles.content}>
            {title && typeof title === 'string' ? <Text>{title}</Text> : title}
            {description && typeof description === 'string' ? <Text level={5}>{description}</Text> : description}
          </View>
          {addon?.right}
          {chevron && <Icon name="right" style={styles.right} size="S" />}
        </View>
        {children}
      </View>
    )
  }
  return (
    <Pressable
      disabled={!onPress || disabled}
      onPress={onPress}
      style={Platform.select({
        // @ts-expect-error outline style none is not defined
        web: {
          outlineStyle: 'none',
        } as ViewStyle,
      })}
      {...otherProps}
    >
      {renderItem}
    </Pressable>
  )
}

export default ListItem
